import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const deletecontract = (state) => {
  return axios.delete(API + "contracts/contract-delete/"+state+"/",{headers: authHeader(),});
};

const DeleteContractService = {
    deletecontract,
  };
  export default DeleteContractService;